import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { SummaryState } from '../type/ai-search.type';

export const AISearchSummaryModel = Symbol('AISearchSummaryModel');

export interface AISearchSummaryModel extends AbstractModel<SummaryState>{}

@injectable()
export class AISearchSummaryModelImpl extends AbstractModelImpl<SummaryState> implements AISearchSummaryModel {
    protected _modelData: SummaryState = {
        summary: [],
        topic: '',
        ipcLoading: false,
        relatedIpc: [],
        loading: false,
        summarySelected: [],
    };
}